// DeliveryMode.jsx
import React, { useState } from "react";
import ModalMondialRelay from "./ModalMondialRelay"; // la modale jQuery Mondial Relay
import "./DeliveryMode.css";

function DeliveryMode({ onRelaySelected }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [relayData, setRelayData] = useState(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Callback quand l’utilisateur confirme le point relais
  const handleRelayChosen = (data) => {
    setRelayData(data);
    // On informe le parent (CheckoutModal) du point relais choisi
    if (onRelaySelected) {
      onRelaySelected(data);
    }
    closeModal();
  };

  return (
    <div className="delivery-mode-container">
      <div className="delivery-mode-header">
        <input type="radio" id="mondial-relay" name="delivery-mode" defaultChecked />
        <label htmlFor="mondial-relay">Mondial relay</label>
        <span className="delivery-price">6,00 € TTC</span>
      </div>

      <p className="delivery-time">3 à 5 jours ouvrables</p>
      <p className="delivery-offer">
        🚚 Frais de port offert pour les prochaines commandes durant le live
      </p>

      <button className="delivery-button" onClick={openModal}>
        {relayData ? "Modifier le point relais" : "Choix du point relais"}
      </button>

      {/* Affiche le point relais sélectionné (nom, adresse, etc.) */}
      {relayData && (
        <div className="selected-relay-block">
          <h4 className="selected-relay-title">Point Relais sélectionné</h4>
          <p className="selected-relay-line">{relayData.Nom}</p>
          <p className="selected-relay-line">{relayData.Adresse1}</p>
          {relayData.Adresse2 && <p className="selected-relay-line">{relayData.Adresse2}</p>}
          <p className="selected-relay-line">
            {relayData.CP} {relayData.Ville}
          </p>
        </div>
      )}

      {/* La modale Mondial Relay (jQuery) */}
      {isModalOpen && (
        <ModalMondialRelay
          onClose={closeModal}
          onChoose={handleRelayChosen}
        />
      )}
    </div>
  );
}

export default DeliveryMode;
